import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import Storefront from './StorefrontApp';
import Admin from './AdminApp';

import './styles/variables.css';
import './styles/global.css';
import './styles/components/buttons.css';
import './styles/components/forms.css';
import './styles/components/cards.css';
import './styles/components/modals.css';
import './styles/components/cart-drawer.css';
import './styles/components/badges.css';
import './styles/components/welcome-popup.css';
import './styles/pages/nav.css';
import './styles/pages/storefront.css';
import './styles/pages/checkout.css';
import './styles/pages/payment.css';
import './styles/pages/admin.css';

export const API_BASE = window.location.hostname === 'localhost'
  ? 'http://localhost:9500'
  : (process.env.REACT_APP_API_BASE || 'https://rugelach-backend-11822543003.us-east1.run.app');

function App() {
  // Checks URL bar parameters on mount to handle direct routing blocks
  const queryParams = new URLSearchParams(window.location.search);
  const initialMode = queryParams.get('view') === 'admin' ? 'admin-login' : 'storefront';
  const initialOrderFilter = queryParams.get('order') || null;

  
  // MANAGED UI MODES
  const [uiMode, setUiMode] = useState(initialMode);
  
  // Global Shared State
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  // Sync Global Products from Backend
  useEffect(() => {
    console.log("🌐 React is attempting to fetch products from backend...");
    fetch(`${API_BASE}/api/products`)
      .then((res) => {
        if (!res.ok) { throw new Error(`HTTP error! Status: ${res.status}`); }
        return res.json();
      })
      .then((data) => {
        console.log("🎯 Successfully received database products:", data);
        setProducts(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ React Fetch Failure Details:", err);
        setLoadError(true);
        setLoading(false);
      });
  }, []);

  const isAdminRoute = uiMode.startsWith('admin');

  return (
    <div className="app-root">
      {isAdminRoute ? (
        <Admin 
		  uiMode={uiMode} 
		  setUiMode={setUiMode} 
		  products={products} 
		  setProducts={setProducts}
		  initialOrderFilter={initialOrderFilter}
		/>
      ) : (
        <Storefront
          uiMode={uiMode}
          setUiMode={setUiMode}
          products={products}
          loading={loading}
          loadError={loadError}
        />
      )}
    </div>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);